<template>
  <div class="civii-cardlist">
    <div class="civii-cardlist-block"
      v-for="(el, index) in list" :key="index">
        <template v-if="!Array.isArray(el) && typeof el === 'object' && el !== null">
          <div class="civii-cardlist-block-title">{{el.title != null ? el.title : index}}</div>
          <div class="civii-cardlist-block-content"><content-render :content="el.content"/></div>
        </template>
        <template v-else-if="typeof el === 'string' || Array.isArray(el)">
          <div class="civii-cardlist-block-title">{{index}}</div>
          <div class="civii-cardlist-block-content"><content-render :content="el"/></div>
        </template>
    </div>
  </div>
</template>

<script>
import ContentRender from '../../widgets/ContentRender/ContentRender.js'

export default {
  components: {
    'content-render': ContentRender
  },
  props: {
    list: Array
  }
}
</script>



// WEBPACK FOOTER //
// src/components/answers/CardList/CardList.vue